<template>
  <form ref="form" @submit.prevent="onSubmit">
    <div class="row g-3">
      <div class="col-sm-6 mx-auto">
        <label class="form-label">{{ $t("titulo") }}</label>
        <input v-model="camposForm.titulo" type="text" class="form-control" required>
      </div>
    </div>
    <div class="row g-3">
      <div class="col-sm-6 mx-auto">
        <label class="form-label">{{ $t("mensagemResumida") }}</label>
        <input v-model="camposForm.mensagemResumida" type="text" class="form-control" required>
      </div>
    </div>
    <div class="row g-3">
      <div class="col-sm-6 mx-auto">
        <label class="form-label">{{ $t("mensagemCompleta") }}</label>
        <textarea v-model="camposForm.mensagemCompleta" type="text" class="form-control" required />
      </div>
    </div>
    <div class="col-lg-4 col-md-6 mx-auto">
      <label class="form-label">{{ $t("status") }}</label>
      <NotificacaoStatusDropdown v-model="camposForm.status" />
    </div>
    <div class="d-grid gap-2 d-md-flex justify-content-md-end">
      <button type="button" class="btn btn-secondary" @click="voltar">
        <span class="bi bi-arrow-return-left"> {{ $t("voltar") }}</span>
      </button>
      <button class="btn btn-primary" @click="submit">
        <span class="bi bi-send">{{ $t("enviar") }}</span>
      </button>
    </div>
  </form>
</template>

<script>
import NotificacaoStatusDropdown from './NotificacaoStatusDropdown.vue';
import { useToast } from 'vue-toastification';
export default {
  components: { NotificacaoStatusDropdown },
  emits: ['enviar-notificacao'],
  data: (props) => ({
    camposForm: {
      titulo: '',
      mensagemResumida: '',
      mensagemCompleta: '',
      status: [0, 1, 2],
    },
  }),
  methods: {
    submit(e) {
      this.$refs.form.checkValidity() && this.validaStatus() && this.enviar(e);
    },
    voltar() {
      this.$router.go(-1); // volta uma página no histórico
    },
    enviar(e) {
      const notificacao = {
        titulo: this.camposForm.titulo,
        mensagem: this.camposForm.mensagemResumida,
        status: this.camposForm.status,
        data: `/notificacao?titulo=${this.camposForm.titulo}&mensagem=${this.camposForm.mensagemCompleta}`,
      };
      this.$emit('enviar-notificacao', notificacao);
      this.camposForm.titulo = '';
      this.camposForm.mensagemResumida = '';
      this.camposForm.mensagemCompleta = '';
      e.preventDefault();
    },
    validaStatus() {
      if (this.camposForm.status && this.camposForm.status.length > 0) {
        return true;
      } else {
        useToast().error('É necessario selecionar pelo menos 1 status');
        return false;
      }
    },
  },
};
</script>
